export enum SUPPLIERS_ID {
  mentalTherapy = 0,
  doctors = 1,
}

export enum SUPPLIER_CATEGORY {
  mentalTherapy = 'therapy',
  doctors = 'medical',
}

export enum SUPPLIERS_STEPS {
  LOBBY = 0,
  FORM = 1,
  RESULTS = 2,
}

export enum SUPPLIERS_RESOURCES {
  profession = 'OCCUP',
  specialty = 'SPECL',
  treatmentMethod = 'GISHA',
  region = 'BRNCD',
  language = 'LNGCD',
  area = 'RGION',
}

export enum SUPPLIER_RESULT_FILTER {
  Init = 'INITIALIZATION',
  Therapy = 'THERAPY_FILTER',
  doctors = 'MEDICAL_FILTER',
}

export enum SUPPLIERS_LOCATION_STEPS {
  region = '1',
  city = '2',
  area = '3',
}
